__turbopack_context__.v({
  "articleCard": "g9SPwG_articleCard",
  "articleContent": "g9SPwG_articleContent",
  "articleExcerpt": "g9SPwG_articleExcerpt",
  "articleImage": "g9SPwG_articleImage",
  "articleMeta": "g9SPwG_articleMeta",
  "articleTitle": "g9SPwG_articleTitle",
  "articlesContainer": "g9SPwG_articlesContainer",
  "articlesGrid": "g9SPwG_articlesGrid",
  "authorAvatar": "g9SPwG_authorAvatar",
  "authorInfo": "g9SPwG_authorInfo",
  "categoryBadge": "g9SPwG_categoryBadge",
  "categoryIcon": "g9SPwG_categoryIcon",
  "categoryName": "g9SPwG_categoryName",
  "featuredArticle": "g9SPwG_featuredArticle",
  "featuredArticleContent": "g9SPwG_featuredArticleContent",
  "featuredArticleExcerpt": "g9SPwG_featuredArticleExcerpt",
  "featuredArticleImage": "g9SPwG_featuredArticleImage",
  "featuredArticleTitle": "g9SPwG_featuredArticleTitle",
  "noArticles": "g9SPwG_noArticles",
  "pageDescription": "g9SPwG_pageDescription",
  "pageHeader": "g9SPwG_pageHeader",
  "pageTitle": "g9SPwG_pageTitle",
  "readMoreLink": "g9SPwG_readMoreLink",
  "searchResultsGrid": "g9SPwG_searchResultsGrid",
  "searchSection": "g9SPwG_searchSection",
  "tag": "g9SPwG_tag",
  "tagsContainer": "g9SPwG_tagsContainer",
});
